import React, { useEffect, useState } from 'react';

const OrbitStarStickyBuyBar = ({ section, onOpen, hidden }) => {
    const [isVisible, setVisible] = useState(false);
    const priced = section.models.filter((model) => model.price);
    const fromPrice = priced.length ? Math.min(...priced.map((model) => model.price)) : null;
    const lengths = [...new Set(section.models.map((model) => model.lengthMetres))].sort((a, b) => a - b);
    const colourCount = Math.max(...section.models.map((model) => model.items.length));
    const note = section.stickyBar.noteTemplate
        .replace('{lengths}', lengths.map((length) => `${length} m`).join(' & '))
        .replace('{colours}', colourCount);

    useEffect(() => {
        const hero = document.getElementById('orbit-star-hero');
        const variants = document.getElementById('variants');
        if (!hero || !variants || typeof IntersectionObserver === 'undefined') return undefined;

        const inView = { hero: true, variants: false };
        const update = (key) => (entries) => {
            inView[key] = entries[entries.length - 1].isIntersecting;
            setVisible(!inView.hero && !inView.variants);
        };
        const heroObserver = new IntersectionObserver(update('hero'));
        // The in-page picker has its own buy buttons, so hide only while it fills the middle of the screen.
        const variantsObserver = new IntersectionObserver(update('variants'), { rootMargin: '-40% 0px -40% 0px' });
        heroObserver.observe(hero);
        variantsObserver.observe(variants);
        return () => {
            heroObserver.disconnect();
            variantsObserver.disconnect();
        };
    }, []);

    return (
        <div className={`orbit-star-sticky-bar${isVisible && !hidden ? ' is-visible' : ''}`} aria-hidden={!isVisible || hidden}>
            <div className="orbit-star-sticky-bar-price">
                {fromPrice ? (
                    <>
                        <span>{section.stickyBar.fromLabel}</span>
                        <strong>{section.currencySymbol}{fromPrice}</strong>
                    </>
                ) : null}
                <small>{note}</small>
            </div>
            <button
                type="button"
                className="orbit-star-sticky-bar-btn"
                tabIndex={isVisible && !hidden ? 0 : -1}
                onClick={() => onOpen('sticky_bar')}
            >
                {section.stickyBar.buttonLabel}
            </button>
        </div>
    );
};

export default OrbitStarStickyBuyBar;
